var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showFullScreenBtn)?_c('div',{staticClass:"full-screen"},[_c('svg-icon',{attrs:{"name":_vm.isFullscreen ? 'exit-fullscreen' : 'fullscreen',"width":"18px","height":"22px"},on:{"click":_vm.handleChange}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }